export default "__VITE_ASSET__c8c28cf2__"